const TrackIcon = (props) => (
  <svg
    width={41}
    height={41}
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32.9674 20.4908H27.2659C26.5824 20.4908 26.0156 19.9239 26.0156 19.2404V7.58749C26.0156 6.35384 26.4991 5.20356 27.366 4.33667C28.2328 3.46979 29.3831 2.98633 30.6168 2.98633H30.6335C32.7173 3.003 34.6845 3.81987 36.1849 5.30358C37.6852 6.82063 38.5021 8.82114 38.5021 10.905V14.9394C38.5188 18.2569 36.2849 20.4908 32.9674 20.4908ZM28.5163 17.9901H32.9674C34.9012 17.9901 36.0182 16.8732 36.0182 14.9394V10.905C36.0182 9.4713 35.4514 8.10429 34.4344 7.0707C33.4175 6.07044 32.0505 5.50363 30.6335 5.48696C30.6335 5.48696 30.6335 5.48696 30.6168 5.48696C30.0667 5.48696 29.5332 5.70368 29.1331 6.10378C28.733 6.50388 28.5163 7.02068 28.5163 7.58749V17.9901Z"
      fill="url(#paint0_linear_868_5038)"
    />
    <path
      d="M15.5986 39.7957C14.815 39.7957 14.0815 39.4956 13.5314 38.9288L10.764 36.1447C10.614 35.9947 10.3806 35.978 10.2139 36.1114L7.36315 38.2453C6.4796 38.9121 5.31264 39.0288 4.31239 38.5287C3.31214 38.0285 2.69531 37.0283 2.69531 35.9113V10.905C2.69531 5.87039 5.57938 2.98633 10.614 2.98633H30.619C31.3026 2.98633 31.8694 3.55314 31.8694 4.23664C31.8694 4.92015 31.3026 5.48696 30.619 5.48696C29.4688 5.48696 28.5352 6.42053 28.5352 7.57082V35.9113C28.5352 37.0283 27.9184 38.0285 26.9181 38.5287C25.9179 39.0288 24.7509 38.9288 23.8673 38.2619L21.0166 36.128C20.8499 35.9947 20.6165 36.028 20.4831 36.1614L17.6824 38.9621C17.1156 39.4956 16.3821 39.7957 15.5986 39.7957ZM10.4473 33.5274C11.2141 33.5274 11.9643 33.8108 12.5311 34.3943L15.2985 37.1783C15.3985 37.2783 15.5319 37.295 15.5986 37.295C15.5819 37.2617 15.7986 37.2783 15.8987 37.1783L18.6994 34.3776C19.733 33.344 21.3667 33.244 22.517 34.1275L25.351 36.2447C25.5344 36.3781 25.7011 36.3281 25.7845 36.2781C25.8678 36.2281 26.0179 36.1281 26.0179 35.9113V7.57082C26.0179 6.82063 26.2013 6.10378 26.518 5.48696H10.5973C6.89637 5.48696 5.17927 7.20406 5.17927 10.905V35.9113C5.17927 36.1447 5.32931 36.2448 5.41266 36.2948C5.51269 36.3448 5.6794 36.3781 5.84611 36.2447L8.69683 34.1109C9.21363 33.7274 9.83045 33.5274 10.4473 33.5274Z"
      fill="url(#paint1_linear_868_5038)"
    />
    <path
      d="M20.181 18.8239H11.012C10.3285 18.8239 9.76172 18.2571 9.76172 17.5736C9.76172 16.8901 10.3285 16.3232 11.012 16.3232H20.181C20.8645 16.3232 21.4313 16.8901 21.4313 17.5736C21.4313 18.2571 20.8645 18.8239 20.181 18.8239Z"
      fill="url(#paint2_linear_868_5038)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_868_5038"
        x1={32.2589}
        y1={2.98633}
        x2={32.2589}
        y2={20.4908}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B03F7B" />
        <stop offset={1} stopColor="#B03F7B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_868_5038"
        x1={17.2823}
        y1={2.98633}
        x2={17.2823}
        y2={39.7957}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B03F7B" />
        <stop offset={1} stopColor="#B03F7B" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_868_5038"
        x1={15.5965}
        y1={16.3232}
        x2={15.5965}
        y2={18.8239}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B03F7B" />
        <stop offset={1} stopColor="#B03F7B" />
      </linearGradient>
    </defs>
  </svg>
);
export default TrackIcon;
